// extracted by mini-css-extract-plugin
export default {"desc":"Desc_desc__X+wJb"};